var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2029_8015)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6159,
    r: 19.5455,
    fill: "#fbfbfb",
    stroke: "#C1C5CF",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7999 28.2V17.4M23.5999 28.2V17.4M16.3999 16.8V14.4C16.3999 13.7373 16.9372 13.2 17.5999 13.2H21.7999C22.4626 13.2 22.9999 13.7373 22.9999 14.4V16.8M12.7999 28.8H27.1999C28.5254 28.8 29.5999 27.7255 29.5999 26.4V19.2C29.5999 17.8745 28.5254 16.8 27.1999 16.8H12.7999C11.4744 16.8 10.3999 17.8745 10.3999 19.2V26.4C10.3999 27.7255 11.4744 28.8 12.7999 28.8Z",
    stroke: "#F9009E",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2029_8015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.615906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetails);
export default __webpack_public_path__ + "static/media/CompanyDetails.6e751c41f2ffd0c95b2041b62aaa3520.svg";
export { ForwardRef as ReactComponent };